module.exports = __webpack_public_path__ + "static/media/bookmarkred.51903f3e.svg";